import React from 'react';
import Header from '../Header';
import ContactUsFooter from './ContactUsFooter';

const ContactUs = () => {
    return (
        <div className="contact-us-container">
            <Header />
            <div className="contactus-content">
                <div className="contactus-image">
                    <img src="/pictures/ContactUs.jpg" alt="Contact Us Illustration" />
                </div>
                <form className="contact-form">
                    <h2>Talk to Us</h2>
                    <div className="input-group">
                        <span className="icon">👤</span>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Name"
                            required
                        />
                    </div>
                    <div className="input-group">
                        <span className="icon">📧</span>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="E-mail"
                            required
                        />
                    </div>
                    <div className="input-group">
                        <textarea
                            id="message"
                            name="message"
                            placeholder="Message"
                            rows="5"
                            required
                        ></textarea>
                    </div>
                    <button type="submit" className="send-button">
                        Send Message
                    </button>
                </form>
            </div>
            <ContactUsFooter />
        </div>
    );
};

export default ContactUs;